export default __webpack_public_path__ + "static/media/inner.c7386bc8.png";